<div class="chart-tile">
  <!-- The header is the drag handle of the page's cdkDrag around this tile. -->
  <div class="chart-tile-header" cdkDragHandle [class.reorderable]="reorderable">
    <h6 class="chart-tile-title" [title]="name">
      Chart:&nbsp; {{ name }}<span *ngIf="chartId != undefined && chartId > 0">&nbsp;(id={{ chartId }})</span>
    </h6>

    <label class="chart-tile-mode" (click)="darkToggle.emit()">
      {{ darkBackground ? 'Chart Light Mode' : 'Chart Dark Mode' }}
    </label>
    <button type="button" class="btn btn-success" (click)="exportRequested.emit()">Export</button>
    <button type="button" class="btn btn-success" (click)="saveRequested.emit()" [disabled]="!canSave">Save</button>
    <i class="fas fa-times chart-tile-close" title="Close this chart" (click)="closeRequested.emit()"></i>
  </div>

  <div class="chart-tile-body">
    <ng-content></ng-content>
  </div>
</div>
